/**
 * 일별 집계 문구 — 서버 `modules/hr/daily-work.ts` 와 **같은 말**을 쓴다 (근태 D1, 2026-08-24).
 *
 * ★ 시간은 언제나 **분이 진실**이고 화면이 나눠 보여 준다(휴가 단위와 같은 규칙).
 */

import type { DailyStatus } from '../api/attendance';

export const DAILY_STATUS_LABEL: Record<DailyStatus, string> = {
  NONE: '기록 없음',
  LEAVE: '휴가',
  DEEMED: '간주 출근',
  OPEN: '근무 중',
  MISSING_CHECKOUT: '퇴근 기록 없음',
  CLOSED: '정상',
};

/** `8시간` · `8시간 30분` · `32분`. 0 이면 `0분`. */
export function formatWorkMinutes(minutes: number): string {
  if (!Number.isFinite(minutes) || minutes <= 0) return '0분';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  const parts: string[] = [];
  if (h > 0) parts.push(`${h}시간`);
  if (m > 0) parts.push(`${m}분`);
  return parts.join(' ');
}

/** `2026-08-23` → `8월 23일`. */
export function formatDayLabel(date: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!m) return date;
  return `${Number(m[2])}월 ${Number(m[3])}일`;
}
